// watch-cart.js
//
// Added on May 14th by jeff@jeffthistle.com to facilitate a My Chemical Romance upsell promotion. If any of the
// 'targetVariants' variant ids are added to the cart, a one-time popup is displayed offering to push 'offerVariant'
// to the cart. 

// const targetVariants = [ 52883485491519, 52883485524287, 52883485557055, 52883485589823, 52883485622591, 52883537756479, 52883608731967, 52883608764735, 52883608797503, 52883608830271, 52883608863039, 52883608895807, 52883639304511, 52883639337279, 52883639370047, 52883639402815, 52883639435583, 52883639468351, 52907175412031, 52907175444799, 52907175477567, 52907175510335, 52907175543103, 52907175575871, 52883660570943, 52883660603711, 52883660636479, 52883660669247, 52883660702015, 52883660734783, 52883668205887, 52883668238655, 52883668271423, 52883668304191, 52883668336959, 52883668369727, 52883686392127, 52883686424895, 52883686457663, 52883686490431, 52883686523199, 52883718013247, 52883718046015, 52883718078783, 52883718111551, 52883718144319, 52883718177087, 52883731644735, 52883731677503, 52883731710271, 52883731743039, 52883731775807, 52883731808575, 52883733446975, 52883799703871, 52883793248575, 52883779289407, 52883806552383, 52883840467263 ];
// const offerVariant = 52880619995455;
const targetVariants = [ 52883485491519, 52883485524287, 52883485557055, 52883485589823, 52883485622591, 52883537756479, 52883608731967, 52883608764735, 52883608797503, 52883608830271, 52883608863039, 52883608895807, 52883639304511, 52883639337279, 52883639370047, 52883639402815, 52883639435583, 52883639468351, 52907175412031, 52907175444799, 52907175477567, 52907175510335, 52907175543103, 52907175575871, 52883660570943, 52883660603711, 52883660636479, 52883660669247, 52883660702015, 52883660734783, 52883668205887, 52883668238655, 52883668271423, 52883668304191, 52883668336959, 52883668369727, 52883686392127, 52883686424895, 52883686457663, 52883686490431, 52883686523199, 52883718013247, 52883718046015, 52883718078783, 52883718111551, 52883718144319, 52883718177087, 52883731644735, 52883731677503, 52883731710271, 52883731743039, 52883731775807, 52883731808575, 52883733446975, 52883799703871, 52883793248575, 52883779289407, 52883806552383, 52883840467263 ];   
const offerVariant = 52880619995455;

document.addEventListener('cart:updated', (event) => {
  checkCartForUpsell(event.detail.cart);

});

async function checkCartForUpsell(cart) {  
  if (!cart || !cart.items) return;
 
console.log('targetVariants', targetVariants);

  if (sessionStorage.getItem('upsell_shown') === 'true') return;
 
  // Check the items already present in the cart object
  const found = cart.items.some(item => targetVariants.includes(item.variant_id));
  if (!found) return;
  
  // Store that we've seen it
  sessionStorage.setItem('upsell_shown', 'true');

  // Try to find the message element, or create it if it doesn't exist
  let messageElement = document.getElementById('custom-upsell-message');

  if (!messageElement) {
    messageElement = document.createElement('div');
    messageElement.id = 'custom-upsell-message';
    
    // Initial Styles - You can move these to your CSS file instead
    Object.assign(messageElement.style, {
      position: 'fixed',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)', // This perfectly centers the element
      zIndex: '2147483647',
      padding: '30px',
      backgroundColor: '#444',
      color: '#fff',
      textAlign: 'center',
      borderRadius: '12px',
      boxShadow: '0 10px 30px rgba(0,0,0,0.2)',
      width: '90%',
      maxWidth: '400px',
      border: '1px solid #ddd',
      display: 'none'
    });

    messageElement.innerHTML = `
      <button id="close-upsell-x" style="
        position: absolute;
        top: 10px;
        right: 10px;
        background: none;
        border: none;
        font-size: 24px;
        cursor: pointer;
        color: #999;
        line-height: 1;
        padding: 5px;
      ">&times;</button>
      <h3 style="margin: 0 0 10px 0; font-size: 18px; line-height: 1.3; font-weight: normal; color: white;">BUY ANY DANGER DAYS<br>MERCH ITEM AND GET<br>THE CD FOR 20% OFF</h3>
      <img src="https://cdn.shopify.com/s/files/1/1052/0910/files/DD15_CD-Retail_1.png?v=1778771538">
      <p style="margin-top: 8px; margin-bottom: 20px; color: #fff; line-height: 1.5;">Danger Days (Deluxe Edition) 2CD<br>$19.98</p>
      <button id="upsell-add-to-cart" style="
        background: #fff;
        color: #000;
        border: 1px solid #000;
        padding: 12px 24px;
        border-radius: 6px;
        cursor: pointer;
        width: 100%;
        font-weight: bold;
      ">Add To Cart</button>
    `;
    
    document.body.appendChild(messageElement);

    // Function to hide the message
    const hideMessage = () => {
      messageElement.style.display = 'none';
      // Optional: Add a class to prevent it from re-opening during this session
      messageElement.dataset.dismissed = 'true';
    };

    const addUpsellOffer = async () => {
        const formData = {
            'items': [{
            'id': offerVariant,
            'quantity': 1
            }]
        };

        try {
            const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData)
            });

            const data = await response.json();
            

            // // Trigger a refresh of the cart UI so the user sees the change
            // document.dispatchEvent(new CustomEvent('cart:updated', {
            // detail: { cart: data }
            // }));

            location.reload();
        } catch (error) {
            console.error('Error adding to cart:', error);
        }
    };

    // Attach listeners to both the X and the main button
    document.getElementById('close-upsell-x').addEventListener('click', hideMessage);
    document.getElementById('upsell-add-to-cart').addEventListener('click', addUpsellOffer);
  }

    messageElement.style.display = 'block';

}